import type {
  DailyMetricResult,
  DateRange,
  HealthDataReader,
  HealthScope,
  PermissionResult,
} from './HealthDataReader';

const EMPTY: DailyMetricResult = { metrics: [], sampleCount: 0 };

export class NullReader implements HealthDataReader {
  readonly platform = 'none' as const;
  isAvailable(): boolean { return false; }
  async requestPermissions(_scopes: HealthScope[]): Promise<PermissionResult> { return { granted: [] }; }
  async getSleep(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getRestingHR(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getHRV(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getSteps(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getActiveEnergy(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getVO2Max(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
}
